import clsx from "clsx";
import DOMPurify from 'dompurify';
import Wrapper from "../../Components/Layout/Wrapper";

import * as styles  from "./styles.module.scss";

export const Paragraph = ({ 
    text, 
    classes = '',
    withMarginTop = false,
    withMarginBottom = false,
    alignCenter = false,
    isHtml = false,
    allowedTags = [],
}) => {
    return (
        <Wrapper>
            <p className={clsx(styles.text, classes, { 
                [styles.textWithMarginTop]: withMarginTop, 
                [styles.textWithMarginBottom]: withMarginBottom,
                [styles.textAlignCenter]: alignCenter,
            })}>
                {(isHtml && allowedTags.length) ? 
                    (
                        <span dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(text, { ALLOWED_TAGS: allowedTags }) }} />
                    ) : 
                    (
                        text
                    )
                }
            </p> 
        </Wrapper>
    );
};